import type { ThirdPartyWithFilesResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetThirdPartyByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetThirdPartyByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetThirdPartyByIdArgs = { thirdPartyId: string };

export const useLazyGetThirdPartyById = createLazyQueryHook<
  UseLazyGetThirdPartyByIdArgs,
  ThirdPartyWithFilesResponseRow[],
  GetThirdPartyByIdQuery
>({
  trpcQuery: (client, { thirdPartyId }) =>
    client.frontend.thirdParty.getById.query({ thirdPartyId }),
  mapTrpcDataToGraphQL: (data) => ({ third_party: data[0] ?? null }),
  graphqlDocument: GetThirdPartyByIdDocument,
  graphqlVariables: ({ thirdPartyId }) => ({ Id: thirdPartyId }),
});
